<template>
    <main class="dashboard">
        <Header />
        
        <div class="main-section">
            <div class="centered_div">
                <SimpleButton :buttonStyle="`linear-gradient(45deg, #f0f4ff, #fafdff)`" @click="asignarAnalistas"
                    class="button-analyst-assign">
                    <span class="assign_text">Asignación Analistas</span> <img :src="assign_logo" class="assign_logo" />
                </SimpleButton>
            </div>
            <div class="container-table table-with-button">
                <b-table :data="sortedData" :loading="this.tableData.loading" ref="table" :total="this.numberRegisters"
                    :show-detail-icon="false">
                    <template #empty>
                        <div class="has-text-centered">
                            No hay cartera de clientes para mostrar
                        </div>
                    </template>
                    <b-table-column field="username" cell-class="columna-panel columna-analista">
                        <template #header>
                            <div class="header-container">
                                <div class="header-title sortButtonLabel" @click="changeSortAnalista">
                                    Analista
                                    <span class="sortButton">{{ orderMsg['nombre'] }}</span>
                                </div>
                            </div>
                        </template>
                        <template #default="{ row }">
                            <span :class="{ 'analyst-name': true, 'highlight-class': row.username === analystName }">
                                {{ row.nombre }}
                            </span>
                        </template>
                    </b-table-column>
                    <b-table-column field="company_type" cell-class="columna-panel columna-tipo-empresa">
                        <template #header>
                            <div class="header-container">
                                <div class="header-title sortButtonLabel" @click="changeSortCompanyType">
                                    Tipo
                                    <span class="sortButton">{{ orderMsg['company_type'] }}</span>
                                </div>
                            </div>
                        </template>
                        <template #default="{ row }">
                            <span :class="['company-type', row.company_type]">
                                {{ row.company_type }}
                            </span>
                        </template>
                    </b-table-column>
                    <b-table-column field="company_rut" cell-class="columna-panel columna-datos-empresa">
                        <template #header>
                            <div class="header-container">
                                <div class="header-title">
                                    Compañia
                                </div>
                                <div class="subheadings">
                                    <table class="noborders">
                                        <tr>
                                            <td>
                                                <div class="sortButtonLabel">
                                                    <span @click="changeSortCompanyRut">RUT <span class="sortButton">{{
                    orderMsg['company_rut'] }}</span></span>
                                                </div>
                                            </td>
                                            <td>
                                                |</td>
                                            <td>
                                                <div class="sortButtonLabel">
                                                    <span @click="changeSortCompanyName">Nombre <span
                                                            class="sortButton">{{
                    orderMsg['company_name'] }}</span></span>
                                                </div>
                                            </td>
                                            <td>
                                                |</td>
                                            <td>
                                                <div class="sortButtonLabel">
                                                    <span @click="changeSortCompanyContact">Contacto <span
                                                            class="sortButton">{{
                    orderMsg['bigger_email'] }}</span></span>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </template>
                        <template #default="{ row, index }">
                            <button class="rut_button" @click="openCompany(row, index)">
                                {{ row.company_rut }}
                            </button>
                            <br />
                            <span class="company-name">
                                {{ row.company_name }}
                            </span><br />
                            <span class="company-contact">
                                {{ row.company_contact }}
                            </span>
                        </template>
                    </b-table-column>
                    <b-table-column field="data_completion" cell-class="columna-panel columna-estado-empresa">
                        <template #header>
                            <div class="header-container">
                                <div class="header-title sortButtonLabel" @click="changeSortStatus">
                                    Estado
                                    <span class="sortButton">{{ orderMsg['completion'] }}</span>
                                </div>
                            </div>
                        </template>
                        <template #default="{ row }">
                            <FileCompletionTable :fileData="row.file_data" :completion="row.completion" />
                        </template>
                    </b-table-column>
                    <b-table-column field="data_completion" cell-class="columna-panel columna-ultimo-registro">
                        <template #header>
                            <div class="header-container">
                                <div class="header-title sortButtonLabel" @click="changeSortLastRecord">
                                    Ultimo registro
                                    <span class="sortButton">{{ orderMsg['last_data'] }}</span>
                                </div>
                            </div>
                        </template>
                        <template #default="{ row }">
                            <span :id="'last_data_' + row.company_id"></span>
                        </template>
                    </b-table-column>
                </b-table>
            </div>
        </div>
    </main>
</template>

<script>
import FileCompletionTable from "@/components/analystPanel/FileCompletionTable";
import Header from "@/components/dashboard/Header";
import SimpleButton from "@/components/modals/SimpleButton";
import AssignAnalysts from "@/components/modals/AssignAnalysts";

import { getCarteraAnalista, getDetalleCompania } from "@/api/carteraAnalista";

let count = 0;

export default {
    name: "PanelAnalista",
    components: {
        Header,
        FileCompletionTable,
        SimpleButton,
    },
    data() {
        return {
            publicPath: "http://" + window.location.hostname,
            analystName: '',
            carteraClientes: [],
            indexPerId: {},
            tableData: {
                loading: true,
                page: 0,
            },
            numberRegisters: 0,
            sortColumn: null,
            sortDirection: null,
            orderMsg: {
                'nombre': '↕',
                'company_rut': '↕',
                'company_name': '↕',
                'bigger_email': '↕',
                'company_type': '↕',
                'completion': '↕',
                'last_data': '↕',
            },
            modalDefaultUpdateSheet: {
                parent: this,
                hasModalCard: true,
                customClass: "modal-class",
                canCancel: ["escape", "outside"],
            },
        };
    },
    mounted() {
        getCarteraAnalista().then((response) => {
            const data = response.data;
            this.analystName = data.analystName;
            this.numberRegisters = data.count;
            this.tableData.loading = false;
            this.carteraClientes.push(...data.objects);
            this.processCompanies(data.objects);
        })
    },
    computed: {
        assign_logo: function () { return `${this.publicPath}/assign.png` },
        sortedData() {
            if (!this.sortColumn) {
                return this.carteraClientes;
            }
            return [...this.carteraClientes].sort((a, b) => {
                var aval = a[this.sortColumn];
                var bval = b[this.sortColumn];
                aval = String(aval).toLowerCase();
                bval = String(bval).toLowerCase();
                if (aval < bval) {
                    return this.sortDirection === 'asc' ? -1 : 1;
                }
                if (aval > bval) {
                    return this.sortDirection === 'asc' ? 1 : -1;
                }
                return 0;
            });
        }
    },
    methods: {
        asignarAnalistas() {
            console.log('asignando');
            this.$buefy.modal.open({
                ...this.modalDefaultUpdateSheet,
                component: AssignAnalysts,
                events: {
                    close: () => {
                    }
                },
            });
        },
        async processCompanies(objects) {
            var index = 0;
            for (const company of objects) {
                this.indexPerId[company.company_id] = index;
                try {
                    const resp = await getDetalleCompania(company.company_id);
                    this.updateCompany(resp, index);
                } catch (error) {
                    console.error('Error fetching company details:', error);
                }
                await this.delay(100);
                index++;
            }
        },
        delay(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        updateCompany(resp, index) {
            this.carteraClientes[index]['company_type'] = resp.data['company_type'];
            this.carteraClientes[index]['file_data'] = resp.data['file_data'];
            this.carteraClientes[index]['completion'] = resp.data['completion'];
            this.carteraClientes[index]['company_contact'] = resp.data['bigger_email'];
            this.carteraClientes[index]['bigger_email'] = resp.data['bigger_email'];
        },
        resetMsgs() {
            for (var key in this.orderMsg) {
                this.orderMsg[key] = '↕';
            }
        },
        changeOrderGeneric(column) {
            if (this.sortColumn != column) {
                count = 0;
                this.sortColumn = column;
            }
            count = (count + 1) % 3;
            this.resetMsgs();
            if (count == 0) {
                this.sortColumn = null;
                this.orderMsg[column] = '↕'
            } else if (count == 1) {
                this.sortColumn = column;
                this.sortDirection = 'asc';
                this.orderMsg[column] = '↑';
            } else if (count == 2) {
                this.sortColumn = column;
                this.sortDirection = 'desc';
                this.orderMsg[column] = '↓';
            }
        },
        changeSortAnalista() {
            this.changeOrderGeneric('nombre');
        },
        changeSortCompanyRut() {
            this.changeOrderGeneric('company_rut');
        },
        changeSortCompanyName() {
            this.changeOrderGeneric('company_name');
        },
        changeSortCompanyContact() {
            this.changeOrderGeneric('bigger_email');
        },
        changeSortCompanyType() {
            this.changeOrderGeneric('company_type');
        },
        changeSortStatus() {
            this.changeOrderGeneric('completion');
        },
        changeSortLastRecord() {
            this.changeOrderGeneric('last_data');
        },
        openCompany(companySelected) {
            this.$router.push({
                name: "companyData",
                query: {
                    companyId: companySelected.company_id,
                    companyRut: companySelected.company_rut
                },
            })
        }
    },
}
</script>
<style scoped>
.highlight-class {
    font-weight: bold;
}

.rut_button {
    border-radius: 1px;
    border: 0;
    padding: 2px 5px;
    background-image: linear-gradient(225deg, #f5f5f5, #fafafa);
    white-space: nowrap;
    filter: drop-shadow(-1px 1px 2px #d0d0d099);
}

.rut_button:hover {
    transform: translateY(-2px);
    filter: drop-shadow(-1px 1px 3px #d0d0d0ff);
}

.rut_button:active {
    transform: translateY(1px);
}

.sortButton {
    border: none;
    background-color: none;
    font-weight: bold;
    -webkit-text-stroke: 1.3px #000;
}

.sortButtonLabel {
    border-radius: 1px;
    padding: 2px 5px;
    background-image: linear-gradient(135deg, #f0f0f0, #fafafa);
    white-space: nowrap;
    filter: drop-shadow(-1px 1px 2px #d0d0d099);
}

.sortButtonLabel:hover {
    transform: translateY(-2px);
    filter: drop-shadow(-1px 1px 2px #d0d0d0ff);
}

.sortButtonLabel:active {
    transform: translateY(1px);
}

.table-with-button {
    /* width: 90%;*/
    align-items: center !important;
}

.subheadings {
    user-select: none;
    white-space: nowrap;
}

div .header-title {
    user-select: none;
    white-space: nowrap;
}

.company-type.BASIC {
    color: blue;
}

.company-type.SPOT,
.company-type.SPOT-CON {
    color: green;
}

.company-type.ENTERPRISE {
    color: red;
}

.company-type.SECONDARY {
    color: orange;
}

.company-type.CLASSIC {
    color: purple;
}

.company-type.ESSENTIAL {
    color: grey;
}

.company-rut {
    font-style: italic;
}

.company-name {
    font-weight: 600;
}

.columna-tipo-empresa {
    background-color: #f00;
}
.button-analyst-assign {
    padding: 2px;
}
.assign_logo {
    width: 34px;
    margin-top: 0px;
}
.assign_text {
    font-size: 16px;
    position: relative;
    top: -8px;
}
.centered_div {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
<style>
.columna-analista {
    white-space: break-spaces !important;
    max-width: 100px !important;
}

.columna-tipo-empresa {
    max-width: 100px !important;
}

.columna-datos-empresa {
    max-width: 200px !important;
}

.columna-estado-empresa {
    max-width: 410px !important;
}

.columna-ultimo-registro {
    max-width: 100px !important;
}

.columna-panel {
    text-align: center !important;
    white-space: nowrap;
}

.table-with-button td,
.table th {
    padding: 0px !important;
}

.table-with-button span:nth-child(1) {
    margin: auto;
}

.table-with-button th {
    text-align: center !important;
}

.table-with-button th:nth-child(1) {
    width: 7em;
    max-width: 150px;
    text-align: center !important;
}

.table-with-button th:nth-child(2) {
    width: 9em;
    max-width: 100px;
}

.table-with-button th:nth-child(3) {
    width: 19em;
    max-width: 250px;
}

.table-with-button th:nth-child(4) {
    width: 7em;
    max-width: 540px;
}

.table-with-button th:nth-child(5) {
    width: 11em;
    max-width: 150px;
}

.table-with-button .b-table .table {
    width: 98%;
}

.table tbody {
    background-image: linear-gradient(135deg, #fefefe, #fafafa);
    border-radius: 2px;
}

.noborders td {
    border: 0 !important;
}
</style>